(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["branche-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function verzamel(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('.h2h-reveal'));
  }

  var els = verzamel(document);
  if (!els.length) return;

  /* In de theme-editor nooit verbergen. Shopify hertekent daar een sectie bij
     elke instelling die je aanraakt, en die verse nodes hebben geen `.in`
     terwijl de verbergklasse allang op <html> staat. Resultaat: de sectie die
     Pim aan het bewerken is verdwijnt tot hij hard herlaadt. De animatie heeft
     in de editor toch geen waarde, dus daar zetten we hem gewoon niet aan. */
  var editor = !!(window.Shopify && window.Shopify.designMode);
  if (editor) return;

  /* Pas hier gaat de verbergregel aan. Hing hij aan `html.js`, dan zette
     js-variables.liquid die klasse al synchroon in de head en bleef de halve
     pagina wit als deze bundel niet laadde of stalde. Nu zet het script dat
     onthult zelf de klasse die verbergt, dus die twee kunnen niet meer los van
     elkaar bestaan. */
  document.documentElement.classList.add('h2h-motion');

  function toon(el, vertraging) {
    if (el.classList.contains('in')) return;
    if (vertraging) { setTimeout(function () { el.classList.add('in'); }, vertraging); }
    else { el.classList.add('in'); }
  }

  /* Scroll-fallback. Die is er niet voor de sier: op de homepage vuurt de
     IntersectionObserver in de praktijk niet, en zonder vangnet blijft dan de
     halve pagina op opacity 0 staan. Dit onthult alleen wat echt in of net
     onder beeld is, dus het scroll-effect blijft bestaan in plaats van dat
     alles in een keer aangaat zoals bij een blinde timer. */
  var wacht = false;
  function loop() {
    wacht = false;
    var grens = window.innerHeight * 1.1;
    var teller = 0;
    els.forEach(function (el) {
      if (el.classList.contains('in')) return;
      var box = el.getBoundingClientRect();
      if (box.top < grens && box.bottom > 0) { toon(el, teller * 80); teller++; }
    });
    opruimen();
  }
  function plan() {
    if (wacht) return;
    wacht = true;
    window.requestAnimationFrame(loop);
  }

  /* Zodra alles onthuld is heeft deze fallback geen werk meer. Zonder dit blijft
     hij op elke scroll een rAF plannen en de hele lijst aflopen. */
  function opruimen() {
    var open = els.some(function (el) { return !el.classList.contains('in'); });
    if (open) return;
    window.removeEventListener('scroll', plan);
    window.removeEventListener('resize', plan);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) { toon(e.target, i * 80); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  window.addEventListener('scroll', plan, { passive: true });
  window.addEventListener('resize', plan, { passive: true });
  plan();

  /* Botte backstop. De twee mechanismen hierboven leunen allebei op iets dat de
     browser mag bevriezen: een IntersectionObserver en requestAnimationFrame
     draaien niet in een tab die niet gerenderd wordt. setTimeout draait wel,
     ook al is hij geknepen. Is er na 2,5 seconde nog helemaal niets onthuld,
     dan is er iets stuk en zet deze alles aan. Zichtbaar zonder animatie is
     altijd beter dan een halve pagina op opacity 0. */
  window.setTimeout(function () {
    if (document.querySelector('.h2h-reveal.in')) return;
    els.forEach(function (el) { el.classList.add('in'); });
  }, 2500);

  /* Tweede net onder de editor-controle hierboven. Staat `Shopify.designMode`
     nog niet als deze bundel draait, dan is `editor` false en is de
     verbergklasse alsnog gezet. Dan vuurt dit event wel, en zetten we de verse
     nodes van de hertekende sectie direct zichtbaar in plaats van ze op
     opacity 0 te laten staan. */
  document.addEventListener('shopify:section:load', function (e) {
    verzamel(e.target).forEach(function (el) {
      el.classList.add('in');
      els.push(el);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["branche-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Per sectie-instantie binden, want op /pages/aanmeten staat deze sectie twee
     keer op dezelfde pagina. Een enkele querySelector zou daar de tweede rij
     door de knoppen van de eerste laten sturen. */
  function bind(rij) {
    if (rij.dataset.brevGebonden) return;
    var blok = rij.closest('.brev');
    var doos = blok && blok.querySelector('[data-brev-knoppen]');
    if (!doos) return;
    var knoppen = Array.prototype.slice.call(doos.querySelectorAll('[data-brev-richting]'));
    if (!knoppen.length) return;

    /* Past alles in beeld, dan is er niets te schuiven en horen de knoppen er
       niet te staan. Dat is de stand bij twee reviews op een breed scherm. */
    function schuifbaar() { return rij.scrollWidth - rij.clientWidth > 8; }

    function stap() {
      var kaart = rij.firstElementChild;
      if (!kaart) return rij.clientWidth;
      var gat = parseFloat(getComputedStyle(rij).columnGap) || 0;
      return kaart.getBoundingClientRect().width + gat;
    }

    function stand() {
      var aan = schuifbaar();
      doos.classList.toggle('brev__knoppen--aan', aan);
      if (!aan) return;
      var eind = rij.scrollWidth - rij.clientWidth - 2;
      knoppen[0].disabled = rij.scrollLeft <= 2;
      knoppen[1].disabled = rij.scrollLeft >= eind;
    }

    knoppen.forEach(function (knop) {
      knop.addEventListener('click', function () {
        var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        rij.scrollBy({ left: stap() * Number(knop.dataset.brevRichting), behavior: zacht ? 'smooth' : 'auto' });
      });
    });

    var wacht = false;
    rij.addEventListener('scroll', function () {
      if (wacht) return;
      wacht = true;
      requestAnimationFrame(function () { wacht = false; stand(); });
    }, { passive: true });
    window.addEventListener('resize', stand);

    rij.dataset.brevGebonden = '1';
    stand();
  }

  function start() {
    Array.prototype.slice.call(document.querySelectorAll('[data-brev-rij]')).forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* De theme-editor hertekent een sectie bij elke instelling die Pim aanraakt.
     Zonder dit blijven de knoppen daar achter op de oude, weggegooide rij. */
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["branche-stappen"] && !Shopify.designMode) return;
  try {
    
/* De mechaniek van de scroll-variant, uit
   nixo-hub/sparring/2026-08-06-scroll-effect-demo/assets/demo.js. Een
   IntersectionObserver met een lijn in het midden van het scherm zet data-step op
   de sectie, de CSS doet de rest. Geen scroll-listener, geen library. Aangepast:
   per sectie in plaats van een per pagina, en de failsafe kiest de stap op de
   plek waar je staat in plaats van stap vijf. html.js zet het thema zelf al (snippets/js-variables). */
(function () {
  'use strict';
  var MOBIEL = window.matchMedia('(max-width: 1023px)');
  var MINDER_BEWEGING = window.matchMedia('(prefers-reduced-motion: reduce)');

  function start(build) {
    if (build.dataset.sscrollKlaar === 'ja') return;
    build.dataset.sscrollKlaar = 'ja';
    var steps = Array.prototype.slice.call(build.querySelectorAll('.build__step'));
    if (!steps.length) return;
    var erIsIetsGebeurd = false;

    // Elke callback telt, ook die zonder raak. De observer meldt zich direct na
    // observe() met de beginstand; blijft dat uit, dan is de tab bevroren. Telde
    // alleen een raak, dan sprong de stage na drie seconden naar de laatste stap
    // terwijl je nog bovenaan de pagina stond, en zag je die scene bij binnenkomst
    // naar stap 1 terugflitsen (Sepp, 28 oktober).
    var observer = new IntersectionObserver(function (entries) {
      erIsIetsGebeurd = true;
      var raak = entries.filter(function (e) { return e.isIntersecting; });
      if (!raak.length) return;
      raak.forEach(function (e) { e.target.classList.add('is-active'); });
      // Op mobiel draagt elke kloon zijn eigen data-step; zet hem hier niet terug
      // op de sectie, anders zie je staten van verschillende stappen door elkaar.
      if (MOBIEL.matches) return;
      var midden = window.innerHeight / 2;
      var beste = raak[0].target, afstand = Infinity;
      raak.forEach(function (e) {
        var r = e.target.getBoundingClientRect();
        var d = Math.abs(r.top + r.height / 2 - midden);
        if (d < afstand) { afstand = d; beste = e.target; }
      });
      build.setAttribute('data-step', beste.getAttribute('data-step'));
      steps.forEach(function (s) { s.classList.toggle('is-active', s === beste); });
    }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });
    steps.forEach(function (step) { observer.observe(step); });

    function bouwMobiel() {
      if (build.dataset.mobielGebouwd === 'ja') return;
      var stage = build.querySelector('.build__stage');
      if (!stage) return;
      steps.forEach(function (step) {
        var houder = document.createElement('div');
        houder.className = 'build__mobile-stage';
        houder.setAttribute('data-step', step.getAttribute('data-step'));
        houder.setAttribute('aria-hidden', 'true');
        houder.appendChild(stage.cloneNode(true));
        step.appendChild(houder);
      });
      build.removeAttribute('data-step');
      build.dataset.mobielGebouwd = 'ja';
    }
    function pasAan() {
      if (MOBIEL.matches) bouwMobiel();
      else if (!build.hasAttribute('data-step')) build.setAttribute('data-step', '1');
    }
    pasAan();
    if (MOBIEL.addEventListener) MOBIEL.addEventListener('change', pasAan);

    var skip = build.querySelector('.build__skip');
    if (skip) {
      skip.addEventListener('click', function (e) {
        var doel = document.querySelector(skip.getAttribute('href'));
        if (!doel) return;
        e.preventDefault();
        doel.scrollIntoView({ behavior: MINDER_BEWEGING.matches ? 'auto' : 'smooth', block: 'start' });
      });
    }

    // Een observer bevriest in een tab die niet rendert, setTimeout niet. Eerst zette
    // de failsafe dan de laatste stap. Een tab die op de achtergrond opent, rendert
    // ook niet: daar stond bij het eerste kijken de eindfoto, die meteen naar stap 1
    // terugsprong (Sepp, 28 oktober: "voordat ik hem echt kan zien, is hij meteen
    // weg"). Nu wacht hij tot de tab zichtbaar is en kiest hij de stap die echt in
    // het midden staat, en anders blijft stap 1 staan.
    function kiesOpPositie() {
      if (erIsIetsGebeurd || MOBIEL.matches) return;
      var midden = window.innerHeight / 2, gekozen = null;
      steps.forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.top <= midden && r.bottom > midden) gekozen = s;
      });
      if (!gekozen) return;
      build.setAttribute('data-step', gekozen.getAttribute('data-step'));
    }
    window.setTimeout(function () {
      if (erIsIetsGebeurd || MOBIEL.matches) return;
      if (document.hidden) {
        document.addEventListener('visibilitychange', function zichtbaar() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', zichtbaar);
          window.setTimeout(volgZelf, 600);
        });
        return;
      }
      volgZelf();
    }, 3000);
    function volgZelf() {
      if (erIsIetsGebeurd) return;
      kiesOpPositie();
      window.addEventListener('scroll', kiesOpPositie, { passive: true });
    }
  }

  function alles() { document.querySelectorAll('[data-sscroll]').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles);
  else alles();
  document.addEventListener('shopify:section:load', alles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keuze-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Per sectie en niet per document: met querySelector pakte dit alleen de
     eerste instantie terwijl de js-klasse wel globaal werd gezet, waardoor de
     tabs van een tweede instantie dode knoppen werden. */
  var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-khero]'));
  if (!wraps.length) return;
  document.documentElement.classList.add('khero-js');
  wraps.forEach(function (wrap) {
  var tabs = Array.prototype.slice.call(wrap.querySelectorAll('.khero__tegel'));
  var panelen = Array.prototype.slice.call(wrap.querySelectorAll('[data-khero-paneel]'));
  if (tabs.length < 2 || tabs.length !== panelen.length) return;

  /* De tab-rollen worden hier gezet en niet in de markup. Zonder javascript is
     dit geen tablist maar een lijst ankers naar de kopjes eronder, en dan mag er
     ook geen tab-semantiek staan. Pas als dit script draait klopt die belofte. */
  var tegelbak = wrap.querySelector('[data-khero-tegels]');
  if (tegelbak) {
    tegelbak.setAttribute('role', 'tablist');
    var label = tegelbak.getAttribute('data-tablist-label');
    if (label) tegelbak.setAttribute('aria-label', label);
  }
  tabs.forEach(function (t) { t.setAttribute('role', 'tab'); });
  panelen.forEach(function (p) { p.setAttribute('role', 'tabpanel'); });

  /* Roving tabindex: alleen de gekozen tab zit in de Tab-volgorde, de rest
     bereik je met de pijltjes, Home en End. Zo kost de kiezer één Tab-stop en
     geen vier (review van 23 oktober). */
  function toon(i) {
    tabs.forEach(function (t, n) {
      t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      t.setAttribute('tabindex', n === i ? '0' : '-1');
    });
    panelen.forEach(function (p, n) {
      if (n === i) {
        p.removeAttribute('hidden');
        /* Een tabpanel hoort focusbaar te zijn, anders komt het toetsenbord na
           het kiezen van een tab niet bij de inhoud die er net verscheen. */
        p.setAttribute('tabindex', '0');
      } else {
        p.setAttribute('hidden', '');
        p.removeAttribute('tabindex');
      }
    });
  }
  toon(0);
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function (e) {
      e.preventDefault();
      toon(i);
      /* Op de telefoon staat het paneel onder de vier tegels en vaak onder de
         vouw, achter de vaste offertebalk. Dan was het enige zichtbare gevolg van
         een tik een oranje tegel. Alleen schuiven als de onderkant van het paneel
         echt buiten beeld valt, zodat desktop en een paneel dat al zichtbaar is
         blijven staan. */
      if (window.innerWidth >= 750) return;
      var paneel = panelen[i];
      var balk = document.querySelector('.branche-sticky-cta');
      var balkHoogte = balk && getComputedStyle(balk).position === 'fixed' ? balk.getBoundingClientRect().height : 0;
      var vak = paneel.getBoundingClientRect();
      var ruimte = window.innerHeight - balkHoogte - 16;
      if (vak.bottom <= ruimte) return;
      /* Nooit verder dan de bovenkant van het paneel onder de vaste kop, anders
         schuift een lang paneel zijn eigen begin uit beeld. */
      var kop = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
      var stap = Math.min(vak.bottom - ruimte, vak.top - kop - 16);
      if (stap <= 0) return;
      var stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollBy({ top: stap, behavior: stil ? 'instant' : 'smooth' });
    });
    /* Pijltjes, Home en End horen te werken in een tablist, anders is het
       toetsenbord-pad kapot. */
    t.addEventListener('keydown', function (e) {
      var volgende;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') volgende = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      else if (e.key === 'Home') volgende = 0;
      else if (e.key === 'End') volgende = tabs.length - 1;
      else return;
      e.preventDefault();
      toon(volgende);
      tabs[volgende].focus();
    });
  });
  toon(0);

  /* Alle panelen even hoog als het langste, anders springt alles eronder bij
     elke keuze een regel op of neer. Opnieuw bij een andere breedte, want dan
     breekt de tekst anders. */
  function gelijk() {
    panelen.forEach(function (p) { p.style.minHeight = ''; });
    var hoogste = 0;
    var open = panelen.filter(function (p) { return !p.hasAttribute('hidden'); })[0];
    var breedte = open ? open.getBoundingClientRect().width : wrap.clientWidth;
    panelen.forEach(function (p) {
      var dicht = p.hasAttribute('hidden');
      if (dicht) { p.style.visibility = 'hidden'; p.style.position = 'absolute'; p.style.width = breedte + 'px'; p.style.animation = 'none'; p.removeAttribute('hidden'); }
      hoogste = Math.max(hoogste, p.getBoundingClientRect().height);
      if (dicht) { p.setAttribute('hidden', ''); p.style.visibility = ''; p.style.position = ''; p.style.width = ''; p.style.animation = ''; }
    });
    panelen.forEach(function (p) { p.style.minHeight = Math.ceil(hoogste) + 'px'; });
  }
  gelijk();
  var wacht;
  window.addEventListener('resize', function () { clearTimeout(wacht); wacht = setTimeout(gelijk, 150); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
/* De inhoudsopgave en de plaatsing van de CTA. Beide draaien op wat er in de body
   staat, en die body is richtext uit de winkel: in Liquid niet te ontleden. Gaat
   dit script niet aan, dan staat de rail verborgen en staat de CTA onder het
   artikel, en dat is precies de toestand van voor 1 september 2026. */
(function () {
  var sectie = document.querySelector('.shopify-section--main-article');
  if (!sectie) return;

  var prose = sectie.querySelector('.article-content .prose');
  var toc = sectie.querySelector('.artikel-toc');
  if (!prose) return;

  var koppen = Array.prototype.slice.call(prose.querySelectorAll('h2'));

  /* Onder de drie koppen is een inhoudsopgave langer dan wat hij ontsluit. */
  if (toc && koppen.length >= 3) {
    var lijst = toc.querySelector('.artikel-toc__lijst');
    var links = [];
    koppen.forEach(function (kop, i) {
      if (!kop.id) {
        var basis = (kop.textContent || '')
          .toLowerCase()
          .replace(/[^a-z0-9\u00e0-\u00ff]+/g, '-')
          .replace(/^-+|-+$/g, '')
          .slice(0, 48);
        kop.id = basis ? 'kop-' + basis : 'kop-' + (i + 1);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + kop.id;
      a.textContent = kop.textContent;
      li.appendChild(a);
      lijst.appendChild(li);
      links.push(a);
    });
    toc.hidden = false;

    /* Welke kop je aan het lezen bent. rootMargin knijpt het venster tot een
       strook onder de header, zodat er altijd precies een kop actief is en de
       markering niet flikkert bij een kop die net in beeld schuift. */
    if ('IntersectionObserver' in window) {
      var actief = null;
      var waarnemer = new IntersectionObserver(function (regels) {
        regels.forEach(function (r) {
          if (!r.isIntersecting) return;
          if (actief) actief.removeAttribute('aria-current');
          var a = links[koppen.indexOf(r.target)];
          if (a) { a.setAttribute('aria-current', 'true'); actief = a; }
        });
      }, { rootMargin: '-96px 0px -70% 0px', threshold: 0 });
      koppen.forEach(function (k) { waarnemer.observe(k); });
    }
  }

  /* De CTA achter de tweede H2. Niet op een percentage van de hoogte: dat komt
     per artikel ergens anders uit. Zijn er minder dan drie koppen, dan blijft hij
     staan waar hij staat, want dan is "achter de tweede kop" zowat het einde. */
  var cta = sectie.querySelector('.artikel-cta');
  if (cta && koppen.length >= 3) {
    var doel = koppen[1];
    var volgende = doel.nextElementSibling;
    /* Onder de kop plus de eerste alinea eronder, anders staat de CTA tussen een
       kop en zijn eigen eerste zin in. */
    var na = volgende && volgende.tagName === 'P' ? volgende : doel;
    na.parentNode.insertBefore(cta, na.nextSibling);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proces-spine"] && !Shopify.designMode) return;
  try {
    
/* Klapt de stappentegels open en dicht. Hover doet de CSS; dit script zet
   `pspine--js` (pas dan klappen de tegels dicht) en regelt tik, toetsenbord en
   de thema-editor. Shopify voegt alle section-javascript samen tot één bestand
   dat op elke pagina laadt, dus het stopt meteen als de sectie er niet is. */
(function () {
  var secties = document.querySelectorAll('.pspine');
  if (!secties.length) return;
  var muis = window.matchMedia('(hover: hover)');
  Array.prototype.forEach.call(secties, function (sectie) {
    sectie.classList.add('pspine--js');
    Array.prototype.forEach.call(sectie.querySelectorAll('[data-pspine-stap]'), function (stap) {
      var knop = stap.querySelector('.pspine-stap__knop');
      if (!knop) return;
      function zet(open) {
        stap.classList.toggle('is-open', open);
        knop.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      /* Op de tegel en niet op de knop, zodat een tik op de open tekst hem ook
         weer sluit. Een klik op de knop zelf bubbelt hierheen, dus één toggle. */
      stap.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        zet(!stap.classList.contains('is-open'));
      });
      stap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && stap.classList.contains('is-open')) { zet(false); knop.focus(); }
      });
      /* Met een muis is hover de bediening; een klik die de tegel openzette
         mag niet blijven hangen als de muis weg is. */
      stap.addEventListener('mouseleave', function () { if (muis.matches) zet(false); });
      stap.addEventListener('shopify:block:select', function () { zet(true); });
      stap.addEventListener('shopify:block:deselect', function () { zet(false); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rie-blad"] && !Shopify.designMode) return;
  try {
    
(function () {
  var toc = document.querySelector('.rie-toc');
  if (!toc) return;

  /* Paren in plaats van twee losse lijsten. Eerder werd de blokken-lijst gefilterd
     met .filter(Boolean) terwijl er gemarkeerd werd op de index van de links-lijst.
     Faalde één getElementById, dan schoven de indexen ten opzichte van elkaar en
     lichtte de rail het verkeerde item op, zonder dat er iets zichtbaar stukging. */
  var paren = Array.prototype.slice.call(toc.querySelectorAll('.rie-toc__link'))
    .map(function (a) {
      var id = a.hash.slice(1);
      /* Het anker komt uit de handle-filter en is dus al url-veilig, maar een
         browser kan hem alsnog geëncodeerd teruggeven. Decoderen mag geen
         uitzondering gooien op een losse procent-teken. */
      try { id = decodeURIComponent(id); } catch (e) {}
      return { link: a, blok: document.getElementById(id) };
    })
    .filter(function (p) { return p.blok; });

  if (paren.length) {
    /* Leespositie in de rail. Geen IntersectionObserver: die geeft bij lange
       blokken meerdere actieve items tegelijk terug en dan knippert de rail.
       Dit kiest er altijd precies een, namelijk het laatste blok dat boven de
       leeslijn begonnen is. */
    var bezig = false;
    function markeer() {
      bezig = false;
      var lijn = window.innerHeight * 0.25;
      var actief = 0;
      for (var i = 0; i < paren.length; i++) {
        if (paren[i].blok.getBoundingClientRect().top <= lijn) actief = i;
      }
      paren.forEach(function (p, i) { p.link.classList.toggle('is-hier', i === actief); });
    }
    function plan() {
      if (bezig) return;
      bezig = true;
      window.requestAnimationFrame(markeer);
    }
    window.addEventListener('scroll', plan, { passive: true });
    window.addEventListener('resize', plan, { passive: true });
    markeer();
  }

  /* De printknop is een button die alleen via JS iets doet, dus hij staat in CSS
     verborgen en gaat pas aan als dit script draait. Anders staat er een knop die
     bij een JS-fout of in een platte render niets doet als je erop klikt. */
  var printknop = toc.querySelector('[data-rie-print]');
  if (printknop) {
    printknop.hidden = false;
    printknop.addEventListener('click', function () { window.print(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spec-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Per sectie-instantie binden; de theme-editor hertekent een sectie bij elke
     instelling, dus `shopify:section:load` bindt de nieuwe opnieuw. */
  function bind(galerij) {
    if (galerij.dataset.sheroGebonden) return;
    var dias = Array.prototype.slice.call(galerij.querySelectorAll('.shero__dia'));
    var duimen = Array.prototype.slice.call(galerij.querySelectorAll('.shero__duim'));
    if (dias.length < 2 || dias.length !== duimen.length) return;

    function laad(dia) {
      if (dia.dataset.srcset) { dia.srcset = dia.dataset.srcset; delete dia.dataset.srcset; }
      if (dia.dataset.src) { dia.src = dia.dataset.src; delete dia.dataset.src; }
    }
    var geladen = false;
    function laadAlles() {
      if (geladen) return;
      geladen = true;
      dias.forEach(laad);
    }

    function kies(i, focus) {
      huidig = i;
      dias.forEach(function (dia, n) {
        var aan = n === i;
        dia.classList.toggle('is-actief', aan);
        if (aan) dia.removeAttribute('aria-hidden'); else dia.setAttribute('aria-hidden', 'true');
        if (aan) laad(dia);
      });
      /* Eén tabstop voor de hele rij; de pijltjes lopen erdoor. */
      duimen.forEach(function (duim, n) {
        if (n === i) duim.setAttribute('aria-current', 'true'); else duim.removeAttribute('aria-current');
        duim.tabIndex = n === i ? 0 : -1;
      });
      if (focus) {
        duimen[i].focus();
        duimen[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    duimen.forEach(function (duim, i) {
      duim.addEventListener('click', function () { kies(i, false); });
      /* Pijltjes lopen door de duimen, zoals in een rij knoppen te verwachten is:
         omhoog en omlaag in de kolom op desktop, links en rechts in de rij op mobiel. */
      duim.addEventListener('keydown', function (e) {
        var stap = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        var doel = null;
        if (stap) doel = (i + stap + duimen.length) % duimen.length;
        else if (e.key === 'Home') doel = 0;
        else if (e.key === 'End') doel = duimen.length - 1;
        if (doel === null) return;
        e.preventDefault();
        kies(doel, true);
      });
    });

    /* Wie naar de duimen gaat, krijgt de beelden vast; anders pas als de
       pagina klaar is en de browser stil ligt, zodat ze het LCP-beeld niet
       in de weg zitten. */
    var rij = galerij.querySelector('.shero__duimen');
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (type) {
      rij.addEventListener(type, laadAlles, { once: true, passive: true });
    });
    function stil() { (window.requestIdleCallback || function (f) { setTimeout(f, 2000); })(laadAlles); }
    if (document.readyState === 'complete') stil(); else window.addEventListener('load', stil, { once: true });

    /* Vegen over het hoofdbeeld, 23 oktober 2026 (Sepp koos optie C uit drie
       telefoonvoorbeelden): de duimen blijven, en op een aanraakscherm veeg je
       ook door de grote foto, zoals in een productgalerij. Alleen een duidelijk
       horizontale veeg telt, zodat verticaal scrollen over de foto blijft werken.
       De actieve duim schuift mee in de rij, zonder de pagina te verschuiven. */
    var hoofd = galerij.querySelector('.shero__hoofd');
    var huidig = 0, startX = null, startY = 0;
    function toonDuim(i) {
      var r = rij.getBoundingClientRect(), d = duimen[i].getBoundingClientRect();
      if (rij.scrollWidth > rij.clientWidth) {
        rij.scrollTo({ left: rij.scrollLeft + (d.left - r.left) - (r.width - d.width) / 2, behavior: 'smooth' });
      }
    }
    hoofd.addEventListener('touchstart', function (e) {
      laadAlles();
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    hoofd.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var doel = (huidig + (dx < 0 ? 1 : -1) + duimen.length) % duimen.length;
      kies(doel, false);
      toonDuim(doel);
    }, { passive: true });

    galerij.sheroKies = function (duim) { var i = duimen.indexOf(duim); if (i > -1) kies(i, false); };
    galerij.dataset.sheroGebonden = '1';
  }

  function start() {
    Array.prototype.slice.call(document.querySelectorAll('[data-shero-galerij]')).forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
  /* In de editor springt de galerij naar het Galerijbeeld-blok dat je kiest. */
  document.addEventListener('shopify:block:select', function (e) {
    var duim = e.target.closest && e.target.closest('.shero__duim');
    var galerij = duim && duim.closest('[data-shero-galerij]');
    if (galerij && galerij.sheroKies) galerij.sheroKies(duim);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
